export const defaultStyles = {
  objectFit: "cover",
  visibility: "visible",
  objectPosition: "center",
  opacity: 1,
  borderRadius: {
    border_left_top_radius: 0,
    border_left_bottom_radius: 0,
    border_right_top_radius: 0,
    border_right_bottom_radius: 0,
  },
  sizing: {
    width: "100%",
    height: "auto",
    minWidth: "100px",
    minHeight: "100px",
    maxWidth: "100%",
    maxHeight: "24rem",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingRight: "0",
    paddingLeft: "0",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginRight: "0",
    marginLeft: "0",
  },
} as const;
